import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BidRoundType, ReportFilterOptions } from '../interfaces/enums';
import { BidRoundDashboardReponse, BidRoundReportResponse } from '../interfaces/responses/models';

@Injectable({
  providedIn: 'root'
})
export class BidRoundService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}bid_rounds/${path}`;
  }

  getBidRound(bid_round_id: string): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl(bid_round_id));
  }

  getBidRounds(): Observable<any> {
    return this.http.get<any>(this.createCompleteUrl(""));
  }

  searchBidRounds(params: any): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}bid_rounds/search/`, { params });
  }

  createBidRound(data: any): Observable<any> {
    return this.http.post<any>(this.createCompleteUrl(""), data);
  }

  updateBidRound(bid_round_id: string, data: any): Observable<any> {
    return this.http.put<any>(this.createCompleteUrl(`${bid_round_id}/update`), data);
  }

  deleteBidRound(bid_round_id: string): Observable<any> {
    return this.http.delete<any>(this.createCompleteUrl(`${bid_round_id}/delete`));
  }

  getBidRoundInformation(bidType: BidRoundType, offset: number): Observable<BidRoundDashboardReponse> {
    const params = new HttpParams().set('bid_type', bidType.valueOf()).set('offset', offset.toString());
    return this.http.get<BidRoundDashboardReponse>(this.createCompleteUrl(`summary/`), { params: params });
  }

  private filterToParams(filter: ReportFilterOptions): HttpParams {
    let params = new HttpParams();
    if (filter === ReportFilterOptions.Accepted || filter === ReportFilterOptions.Rejected) {
      params = params.set('bid_status', filter.valueOf().toUpperCase());
    } else if (filter === ReportFilterOptions.Buyers) {
      params = params.set('transaction_type', 'Buy');
    } else if (filter === ReportFilterOptions.Sellers) {
      params = params.set('transaction_type', 'Sell');
    }
    return params;
  }

  getBidRoundReport(bidRoundId: string, filter: ReportFilterOptions): Observable<BidRoundReportResponse> {
    const params = this.filterToParams(filter).set('bid_round_id', bidRoundId);
    return this.http.get<BidRoundReportResponse>(this.createCompleteUrl(`bids/`), { params: params });
  }

  downloadReport(bidRoundId: string, filter: ReportFilterOptions): Observable<Blob> {
    const params = this.filterToParams(filter).set('bid_round_id', bidRoundId);
    return this.http.get(this.createCompleteUrl(`bids/export/`), { 
      params: params, 
      responseType: 'blob' 
    });
  }
}
